var render = function render(){var _vm=this,_c=_vm._self._c;return _c('archive-toggle-button',{attrs:{"archived":_vm.archived,"archiveLocked":_vm.archiveLocked},on:{"toggle":_vm.toggleArchive}})
}
var staticRenderFns = []

export { render, staticRenderFns }